import ColumnForm from '../components/ColumnForm';
import MobileColumnForm from '../components/MobileColumnForm';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { withoutHiddenStatuses } from 'src/helpers/seance/seanceStatus';
import ChangeCaseComponent from '../components/ChangeCaseComponent';
import { changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import { ChangeComponentTime, ChangeComponentSelect, ChangeComponentField } from 'src/components/ChangeComponent';
import classNames from 'classnames';
import moment from 'moment';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faFileSignature,
    faPencilAlt,
    faSyncAlt,
    faDollarSign,
    faListAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { DropdownList } from 'react-widgets';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import * as React from 'react';
import { ICase } from 'src/types/case';
import user from 'src/services/user-auth';
import UserRole from 'src/enumerables/user-role';
import { IProvider } from '../../../../../../../../../types/provider';
import { Dispatch } from 'redux';
import { updateSeance } from '../../../../../../../../../store/actions/seance-actions';
import CaseEnum from '../../../../../../../../../enumerables/case-enum';
import { toast } from 'react-toastify';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import DataSheetLabel from '../../../../../../../../../components/common/DatasheetLabel';

interface Params {
    id: string;
    setOpenDrop: (val: boolean) => void;
    month: { monthEnd: string; monthStart: string };
    caseCurrent: ICase | null;
    dispatch: Dispatch;
    setCurrentAction: (val: string) => void;
    canInvoice: boolean;
    setRatePer: (val: boolean) => void;
    statusEnum: any;
    isRate: boolean;
    provider: Partial<IProvider> | null;
    setPopup: (val: boolean) => void;
    setCurrentActionData: (val: any) => void;
    caseValues: SelectObject[];
    serviceTypes: SelectObject[];
    serviceLocations: SelectObject[];
    setFormColumn: (val: any) => void;
    formColumn: any;
    existData: any;
    setExistData: any;
    dataSaveModal: any;
    setSaveModal: any;
    valueOrderTypeLabel: any;
    setValueOrderTypeLabel: any;
}

const getRowsSession = (
    data: any,
    {
        formColumn,
        setOpenDrop,
        month,
        id,
        provider,
        isRate,
        setRatePer,
        caseCurrent,
        dispatch,
        serviceLocations,
        serviceTypes,
        canInvoice,
        setCurrentAction,
        statusEnum,
        setPopup,
        setCurrentActionData,
        caseValues,
        setFormColumn,
        existData,
        setExistData,
        dataSaveModal,
        setSaveModal,
        valueOrderTypeLabel,
        setValueOrderTypeLabel,
    }: Params,
) => {
    const MinPerUnit = CaseEnum ? CaseEnum.getEnum('MinPerUnit') : {};
    const minPerUnitData: SelectObject[] = getValFromEnum(MinPerUnit);
    const isProvider =
        !user.getRoles().includes(UserRole.ROLE_ADMIN) && provider?.userProviders && !provider.userProviders.length;
    const isMobile = window.innerWidth <= 800;
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);

    const dataSessionComponents: any = [];
    if (isMobile && formColumn === true) {
        if (formColumn === true) {
            dataSessionComponents.push({
                ColumnForm: isMobile ? MobileColumnForm : ColumnForm,
                provider: { ...provider },
                month,
                occasion: caseCurrent,
                providerId: id,
                setOpenDrop,
                existData,
                setExistData,
                dataSaveModal,
                setSaveModal,
            });
        }
    } else {
        data.forEach((itSes: any, k: any) => {
            if (+itSes.status === 5) {
                return false;
            }
            if (`${formColumn}` === `${itSes['id']}`) {
                dataSessionComponents.push({
                    ColumnForm: isMobile ? MobileColumnForm : ColumnForm,
                    setOpenDrop,
                    month,
                    providerId: id,

                    ...itSes,
                    provider: { ...provider },
                    occasion: caseCurrent,
                    existData,
                    setExistData,
                    dataSaveModal,
                    setSaveModal,
                });
                return false;
            }

            if (caseCurrent?.caseType !== 2 && itSes.status !== 4 && itSes.status !== 5) {
                canInvoice = false;
            }

            const statusItems: SelectObject[] = getValFromEnum(statusEnum);

            let valueCaseStatus: SelectObject = { label: '', value: '' };
            let canConfirm = true;
            let seanceFuture = false;

            const time = itSes.endTime ? changeToZeroZoneDate(itSes.endTime).getTime() : 0;
            const timeNow = new Date().getTime();

            if (time > timeNow) {
                canConfirm = false;
                seanceFuture = true;
            }
            statusItems.forEach((it, l, arr) => {
                if (+it.value === +itSes.status) {
                    valueCaseStatus = { ...it };
                }
                if (it.value === 4 && !itSes.signDoc) {
                    canConfirm = false;
                }
            });

            if (!canConfirm) {
                statusItems.forEach((it, l, arr) => {
                    if (it.value === 4) {
                        statusItems.splice(l, 1);
                    }
                });
            }
            if (!isAdmin && itSes.hasPaid) {
                statusItems.forEach((it, l, arr) => {
                    if (it.value === 5) {
                        statusItems.splice(l, 1);
                    }
                });
            }
            let serviceType = itSes?.serviceType?.title;
            if (!serviceType) {
                serviceType = itSes?.serviceType?.cpt;
            }

            const locationArr: string[] = [];
            locationArr.push(itSes['serviceLocation'] ? itSes['serviceLocation']?.title : '');
            if (itSes.isHome) {
                locationArr.push('[Home In Person]');
            }
            if (itSes.isInPerson) {
                locationArr.push('[School - In Person]');
            }
            if (itSes.isTelehealth) {
                locationArr.push('[Telehealth]');
            }
            if (itSes.isSchool) {
                locationArr.push('[School - Telehealth]');
            }
            const locationTitle = locationArr.join(', ');
            const today = new Date();
            const toCase: any = user.getRoles().includes(UserRole.ROLE_ADMIN)
                ? {
                    toCase: (
                        <ChangeCaseComponent
                            sessionId={itSes['id']}
                            month={month}
                            providerId={id}
                            caseValues={caseValues}
                            caseCurrent={caseCurrent}
                        />
                    ),
                }
                : {};

            let addFields = {};
            if (itSes?.occasion?.caseType === 3) {
                addFields = {
                    seanceInfo: (
                        <ChangeComponentField
                            noEdit={
                                (isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)
                            }
                            action={(data: any, act: (date: any, valueD: any) => void) => {
                                return dispatch(
                                    updateSeance(
                                        {
                                            id: itSes.id,
                                            seanceInfo: data,
                                            isWeekly: false,
                                            editMode: true,
                                        },
                                        () => {
                                            act(data, data);
                                            toast.success('Session was successfully updated');
                                        },
                                        (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    ),
                                );
                            }}
                            value={itSes?.seanceInfo ? itSes?.seanceInfo : ''}
                            data={itSes?.seanceInfo ? itSes?.seanceInfo : ''}
                        />
                    ),
                };
            }

            if ((itSes?.occasion?.caseType && itSes?.occasion?.caseType === 2) || itSes?.occasion?.caseType === 3) {
                addFields = {
                    ...addFields,
                    minPerUnit: (
                        <ChangeComponentSelect
                            action={(data: any, act: any) => {
                                return dispatch(
                                    updateSeance(
                                        {
                                            id: itSes.id,
                                            minPerUnit: data.value,
                                            isWeekly: false,
                                            editMode: true,
                                        },
                                        () => {
                                            act(data.value, data);
                                            toast.success('Session was successfully updated');
                                        },
                                        (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    ),
                                );
                            }}
                            setOpenDrop={setOpenDrop}
                            noEdit={
                                (isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)
                            }
                            dataList={minPerUnitData}
                            data={itSes.minPerUnit}
                            value={{ value: itSes.minPerUnit }}
                        />
                    ),
                    serviceLocation: (
                        <ChangeComponentSelect
                            action={(data: any, act: any) => {
                                return dispatch(
                                    updateSeance(
                                        {
                                            id: itSes.id,
                                            serviceLocation: data.value,
                                            isWeekly: false,
                                            editMode: true,
                                        },
                                        () => {
                                            act(data.label, data);
                                            toast.success('Session was successfully updated');
                                        },
                                        (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    ),
                                );
                            }}
                            setOpenDrop={setOpenDrop}
                            noEdit={
                                (isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)
                            }
                            dataList={serviceLocations}
                            data={locationTitle}
                            value={{ value: itSes.serviceLocation?.id }}
                        />
                    ),
                    serviceType: (
                        <ChangeComponentSelect
                            action={(data: any, act: (date: any, valueD: any) => void) => {
                                return dispatch(
                                    updateSeance(
                                        {
                                            id: itSes.id,
                                            serviceType: data.value,
                                            isWeekly: false,
                                            editMode: true,
                                        },
                                        () => {
                                            act(data.label, data);
                                            toast.success('Session was successfully updated');
                                        },
                                        (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    ),
                                );
                            }}
                            noEdit={
                                (isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)
                            }
                            setOpenDrop={setOpenDrop}
                            dataList={serviceTypes}
                            data={serviceType}
                            value={{ value: itSes?.serviceType?.id }}
                        />
                    ),
                };
            }
            let start: any = '';
            let end: any = '';
            if (itSes.startTime && moment(itSes.startTime, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                start = moment(itSes.startTime, 'YYYY-MM-DD HH:mm:ss').toDate();
            } else {
                start = changeToZeroZoneDate(itSes.startTime);
            }
            if (itSes.endTime && moment(itSes.endTime, 'YYYY-MM-DD HH:mm:ss').isValid()) {
                end = moment(itSes.endTime, 'YYYY-MM-DD HH:mm:ss').toDate();
            } else {
                end = changeToZeroZoneDate(itSes.endTime);
            }

            const dataSheet: string = itSes.datasheet.join(',');
            const pushItem: any = {
                ...itSes,
                serviceLocation: <div>{locationTitle}</div>,
                serviceType: <div>{serviceType}</div>,
                externalRatePerHour: itSes.externalRatePerHour
                    ? `$${numberWithCommas(itSes.externalRatePerHour)}`
                    : '$0.00',
                externalRatePerUnit: itSes.externalRatePerUnit
                    ? `$${numberWithCommas(itSes.externalRatePerUnit)}`
                    : '$0.00',
                internalRatePerHour: itSes.internalRatePerHour
                    ? `$${numberWithCommas(itSes.internalRatePerHour)}`
                    : '$0.00',
                internalRatePerUnit: itSes.internalRatePerUnit
                    ? `$${numberWithCommas(itSes.internalRatePerUnit)}`
                    : '$0.00',
                totalFee: itSes.totalFee ? `$${numberWithCommas(itSes.totalFee)}` : '$0.00',
                totalUnit: itSes.totalUnit,
                ...toCase,
                provider: { ...provider },

                datasheet: <DataSheetLabel text={dataSheet} />,
                rate: isMobile ? (
                    <div className={classNames(styles.rateBtn)} onClick={() => setRatePer(!isRate)}>
                        <FontAwesomeIcon icon={isRate ? faAngleDoubleUp : faAngleDoubleDown} />
                        <span></span>
                    </div>
                ) : (
                    <div className={classNames(styles.arrowBtn)} onClick={() => setRatePer(!isRate)}></div>
                ),
                action: (
                    <div style={{ display: 'flex' }}>
                        {!itSes['signDoc'] ? (
                            <button
                                className={classNames(styles.editBtn, 'btn btn-info')}
                                type={'button'}
                                onClick={() => {
                                    setCurrentAction('SIGN');
                                    setPopup(true);
                                    setCurrentActionData({ id: `${itSes['id']}`, seanceFuture });
                                }}
                            >
                                {isMobile ? 'Sign' : <FontAwesomeIcon icon={faFileSignature} />}
                            </button>
                        ) : (
                            ''
                        )}
                        {(isProvider && itSes.status === 4 && itSes['signDoc']) ||
                        (!isAdmin && itSes.hasPaid) ? null : (
                            <button
                                className={classNames(styles.editBtn, 'btn btn-info')}
                                type={'button'}
                                onClick={() => {
                                    if (formColumn !== itSes['id']) {
                                        setFormColumn(itSes['id']);
                                    }
                                }}
                            >
                                <span>
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                    <span></span>
                                </span>
                            </button>
                        )}
                    </div>
                ),
                id: (
                    <Link
                        to={Router.generate(routes.PROVIDER_DETAIL, {
                            subId: itSes['id'],
                            id: id,
                            tab: 'case-sessions-edit',
                        })}
                        target="_blank"
                    >
                        {itSes['id']}
                    </Link>
                ),
                signDoc: itSes['signDoc'] ? (
                    <a rel="noopener noreferrer" target="_blank" href={`${itSes['signDoc']}`}>
                        Note
                    </a>
                ) : (
                    ''
                ),
                isConfirmed: +valueCaseStatus.value === 4 ? true : false,
                status: (
                    <div style={{ minWidth: 150, maxWidth: 150, textAlign: 'center' }}>
                        {isProvider && +valueCaseStatus.value === 4 ? (
                            valueCaseStatus.label
                        ) : (
                            <div className={classNames(styles.status)}>
                                <DropdownList
                                    //       this.state.status statusItems
                                    data={withoutHiddenStatuses(statusItems)}
                                    textField="label"
                                    valueField="value"
                                    onChange={(item: SelectObject) => {
                                        setCurrentAction('CHANGE_STATUS');
                                        setPopup(true);
                                        setCurrentActionData({
                                            id: `${itSes['id']}`,
                                            status: item.value,
                                            label: item.label,
                                        });
                                    }}
                                    onToggle={(isOpen) => {
                                        if (isMobile) {
                                        } else {
                                            if (isOpen) {
                                                setOpenDrop(true);
                                            } else {
                                                setOpenDrop(false);
                                            }
                                        }
                                    }}
                                    dropUp
                                    value={valueCaseStatus}
                                />
                                <span className={classNames(styles.icon)}>
                                    {/*          <FontAwesomeIcon icon={faAngleDown} />
                                    <span></span>*/}
                                </span>
                            </div>
                        )}
                    </div>
                ),
                ...addFields,
                seanceDateLabel: (
                    <div className={classNames(styles.date)}>
                        {changeToZeroMoment(itSes['seanceDate'], 'MMM D, YYYY')}
                        {itSes.isWeekly ? (
                            <FontAwesomeIcon
                                style={{
                                    position: 'absolute',
                                    bottom: '5px',
                                    top: 'auto',
                                    fontSize: '10px',
                                    right: '3%',
                                }}
                                icon={faSyncAlt}
                            />
                        ) : null}
                        {isAdmin && itSes.hasPaid ? (
                            <div className={classNames(styles.dollarIcon)}>
                                <FontAwesomeIcon icon={faDollarSign} />
                            </div>
                        ) : isAdmin && itSes.hasInvoiced ? (
                            <div className={classNames(styles.dollarIcon, styles.invoicedIcon)}>
                                <FontAwesomeIcon icon={faListAlt} />
                            </div>
                        ) : null}
                    </div>
                ),

                seanceDate: itSes.seanceDate ? (
                    <ChangeComponentTime
                        noEdit={(isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)}
                        value={itSes.seanceDate ? changeToZeroZoneDate(itSes['seanceDate']) : undefined}
                        time={false}
                        date={true}
                        min={
                            itSes.occasion?.caseNumberValidityFrom
                                ? new Date(itSes.occasion?.caseNumberValidityFrom)
                                : undefined
                        }
                        max={
                            itSes.occasion?.caseNumberValidityTo
                                ? new Date(itSes.occasion?.caseNumberValidityTo)
                                : undefined
                        }
                        format={'MMM D, YYYY'}
                        setOpenDrop={setOpenDrop}
                        action={(date: any, dateStr: any, act: any) => {
                            const resData = moment(date).format('YYYY-MM-DD');

                            const hoursEnd = +changeToZeroMoment(itSes['endTime'], 'HH');

                            const minEnd = +changeToZeroMoment(itSes['endTime'], 'mm');
                            const endTime = moment(date)
                                .set('hour', hoursEnd)
                                .set('minute', minEnd)
                                .set('second', 0)
                                .format('YYYY-MM-DD HH:mm:ss');

                            const hoursStart = +changeToZeroMoment(itSes['startTime'], 'HH');

                            const minStart = +changeToZeroMoment(itSes['startTime'], 'mm');
                            const startTime = moment(date)
                                .set('hour', hoursStart)
                                .set('minute', minStart)
                                .set('second', 0)
                                .format('YYYY-MM-DD HH:mm:ss');

                            return dispatch(
                                updateSeance(
                                    {
                                        id: itSes.id,
                                        seanceDate: resData,
                                        endTime,
                                        startTime,
                                        isWeekly: false,
                                        editMode: true,
                                    },
                                    () => {
                                        const actData = (
                                            <div className={classNames(styles.date)}>
                                                {moment(date).format('MMM D, YYYY')}
                                                {itSes.isWeekly ? (
                                                    <FontAwesomeIcon
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '5px',
                                                            top: 'auto',
                                                            fontSize: '10px',
                                                            right: '3%',
                                                        }}
                                                        icon={faSyncAlt}
                                                    />
                                                ) : null}
                                                {isAdmin && itSes.hasPaid ? (
                                                    <div className={classNames(styles.dollarIcon)}>
                                                        <FontAwesomeIcon icon={faDollarSign} />
                                                    </div>
                                                ) : isAdmin && itSes.hasInvoiced ? (
                                                    <div className={classNames(styles.dollarIcon, styles.invoicedIcon)}>
                                                        <FontAwesomeIcon icon={faListAlt} />
                                                    </div>
                                                ) : null}
                                            </div>
                                        );
                                        act(actData, date);
                                        toast.success('Session was successfully updated');
                                    },
                                    (errorMessage: string) => {
                                        toast.error(errorMessage);
                                    },
                                ),
                            );
                        }}
                        data={
                            <div className={classNames(styles.date)}>
                                {changeToZeroMoment(itSes['seanceDate'], 'MMM D, YYYY')}
                                {itSes.isWeekly ? (
                                    <FontAwesomeIcon
                                        style={{
                                            position: 'absolute',
                                            bottom: '5px',
                                            top: 'auto',
                                            fontSize: '10px',
                                            right: '3%',
                                        }}
                                        icon={faSyncAlt}
                                    />
                                ) : null}
                                {isAdmin && itSes.hasPaid ? (
                                    <div className={classNames(styles.dollarIcon)}>
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </div>
                                ) : isAdmin && itSes.hasInvoiced ? (
                                    <div className={classNames(styles.dollarIcon, styles.invoicedIcon)}>
                                        <FontAwesomeIcon icon={faListAlt} />
                                    </div>
                                ) : null}
                            </div>
                        }
                    />
                ) : (
                    ''
                ),
                startTime: itSes.startTime ? (
                    <ChangeComponentTime
                        value={itSes.startTime ? start : undefined}
                        time={true}
                        format={'LT'}
                        noEdit={(isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)}
                        step={15}
                        action={(date: any, dateStr: any, act: any) => {
                            const dateTimeF: any = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();

                            const hoursEnd = +moment(dateTimeF).format('HH');

                            const minEnd = +moment(dateTimeF).format('mm');
                            const dateTime = moment(itSes['seanceDate'])
                                .set('hour', hoursEnd)
                                .set('minute', minEnd)
                                .set('second', 0)
                                .format('YYYY-MM-DD HH:mm:ss');

                            return dispatch(
                                updateSeance(
                                    {
                                        id: itSes.id,
                                        startTime: dateTime,
                                        isWeekly: false,
                                        editMode: true,
                                    },
                                    () => {
                                        //dateTimeF = dateTimeF.toISOString();

                                        act(moment(dateTimeF).format('LT'), dateTimeF);
                                        toast.success('Session was successfully updated');
                                    },
                                    (errorMessage: string) => {
                                        toast.error(errorMessage);
                                    },
                                ),
                            );
                        }}
                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                        date={false}
                        setOpenDrop={setOpenDrop}
                        data={changeToZeroMoment(itSes['startTime'], 'LT')}
                    />
                ) : (
                    ''
                ),
                endTime: itSes.endTime ? (
                    <ChangeComponentTime
                        value={itSes.endTime ? end : undefined}
                        time={true}
                        date={false}
                        step={15}
                        noEdit={(isProvider && itSes.status === 4 && !!itSes['signDoc']) || (!isAdmin && itSes.hasPaid)}
                        min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                        max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                        format={'LT'}
                        setOpenDrop={setOpenDrop}
                        action={(date: any, dateStr: any, act: any) => {
                            const dateTimeF = dateStr ? moment(dateStr, 'h:m A').toDate() : new Date();

                            const hoursEnd = +moment(dateTimeF).format('HH');

                            const minEnd = +moment(dateTimeF).format('mm');
                            const dateTime = moment(itSes['seanceDate'])
                                .set('hour', hoursEnd)
                                .set('minute', minEnd)
                                .set('second', 0)
                                .format('YYYY-MM-DD HH:mm:ss');

                            return dispatch(
                                updateSeance(
                                    {
                                        id: itSes.id,
                                        endTime: dateTime,

                                        isWeekly: false,
                                        editMode: true,
                                    },
                                    () => {
                                        act(moment(dateTimeF).format('LT'), dateTimeF);
                                        toast.success('Session was successfully updated');
                                    },
                                    (errorMessage: string) => {
                                        toast.error(errorMessage);
                                    },
                                ),
                            );
                        }}
                        data={changeToZeroMoment(itSes['endTime'], 'LT')}
                    />
                ) : (
                    ''
                ),
            };

            dataSessionComponents.push(pushItem);
        });
        if (formColumn === true) {
            dataSessionComponents.push({
                ColumnForm: isMobile ? MobileColumnForm : ColumnForm,
                provider: { ...provider },
                month,
                occasion: caseCurrent,
                providerId: id,
                setOpenDrop,
                existData,
                setExistData,
                dataSaveModal,
                setSaveModal,
            });
        }
    }

    return dataSessionComponents;
};
export default getRowsSession;
